import { axiosApi } from '@/api/axios';

export default {
  authenticate(userCredentials) {
    return axiosApi.post('/sessions', userCredentials);
  },
  setPassword(params) {
    return axiosApi.post('/passwords/set', params);
  },
  recoverPassword(params) {
    return axiosApi.post('/passwords/recover', params);
  },
  getUser(id) {
    return axiosApi.get(`/users/${id}`);
  },
};
